export const TX_BROADCASTED = 'TX_BROADCASTED'
export const TX_CONFIRMATION = 'TX_CONFIRMATION'
export const TX_SUCCESSFUL = 'TX_SUCCESSFUL'
export const TX_ERROR = 'TX_ERROR'
export const PUSH_TO_TXSTACK = 'PUSH_TO_TXSTACK'
export const POP_FROM_TXSTACK = 'POP_FROM_TXSTACK'
